import type { FieldValues, Path, UseFormRegister } from 'react-hook-form';
import type { KeyboardEventHandler } from 'react';
import styled from 'styled-components';
import { BasicInputStyles } from './BasicInput';
import { shouldAutoFill } from '../../../common/utils/autoFill';

type InputEmailProps<Fields extends FieldValues> = {
  id?: string;
  label?: string;
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
  value?: string | number;
  inputSize?: string;
  name: Path<Fields>;
  register?: UseFormRegister<Fields>;
  defaultValue?: string;
  onKeyUp?: KeyboardEventHandler<HTMLInputElement>;
  autoFill?: boolean;
};

const Input = styled(BasicInputStyles)``;

const InputEmail = <Fields extends FieldValues>({
  id,
  errorMessage,
  required,
  disabled,
  value,
  name,
  register,
  inputSize = 'md',
  label,
  onKeyUp,
  defaultValue,
  autoFill
}: InputEmailProps<Fields>) => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const registerFunc = register ? register : () => {};
  const fill = shouldAutoFill(autoFill);
  return (
    <Input
      id={id ? `${id}-input-email` : undefined}
      type="email"
      value={value}
      required={required}
      inputSize={inputSize}
      disabled={disabled}
      errorMessage={errorMessage}
      onKeyUp={onKeyUp}
      {...registerFunc(name)}
      alt={label}
      defaultValue={defaultValue}
      autoComplete={fill}
    />
  );
};

export { InputEmail };
